<p-menubar>
  <!--left side-->
  <ng-template pTemplate="start">
    <img [src]="logo" alt="Brand Logo" class="logo clickable" (click)="goHome()">
  </ng-template>
  <!--right side-->
  <ng-template pTemplate="end">
    <!--user name-->
    <span>{{userName}}</span>
    <!--user options-->
    <p-menu #menu [model]="items" [popup]="true"></p-menu>
    <!-- <i class="pi pi-user clickable" [title]="'_.user-options' | translate" (click)="menu.toggle($event)"></i> -->
    <img src="./assets/img/icons/user-black.svg" [title]="'_.user-options' | translate" class="icon clickable" (click)="menu.toggle($event)">
    <!--prices-->
    <i class="pi pi-euro clickable" [title]="'prices.title' | translate" (click)="prices()" *ngIf="budgetPermission"></i>
    <!--logout-->
    <img src="./assets/img/icons/poweroff.svg" [title]="'button.logout' | translate" class="icon clickable" (click)="logout()">
  </ng-template>
</p-menubar>
